<template>
  <div class="padding80">
    <Header :current="4"/>
    <div class="sidebar">
      <div v-for="item in menus">
        <div class="menu-title active" @change="item.expand = !item.expand">
          <div class="title">{{ item.title }}</div>
          <img class="icon" src="../../assets/arrow-up.png" alt="">
        </div>
        <div :class="['menu-child', item.expand ? '' : 'shrink']">
          <div class="menu-item" v-for="child in item.children" @click="changeMenu(child)">
            <span :class="currentMenu === child.component ? 'active' : ''">
              {{ child.title }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <component :is="currentMenu" v-if="currentMenu"/>
    </div>
  </div>
</template>

<script>
import Sdk from "./components/Sdk.vue";
import Privacy from "./components/Privacy.vue";

export default {
  name: "document",
  components: {Sdk, Privacy},
  data() {
    return {
      menus: [{
        title: '政策协议',
        expand: true, // 默认展开
        children: [
          {title: 'SDK合规说明', component: 'Sdk'},
          {title: '隐私政策', component: 'Privacy'}
        ]
      }],
      currentMenu: 'Sdk', // 当前选中菜单
    };
  },
  methods: {
    // 切换菜单
    changeMenu(childM) {
      this.currentMenu = childM.component;
      const dom = document.querySelector('.content');
      dom.scrollTo({top: 0});
    }
  }
};
</script>

<style scoped lang="less">
.sidebar {
  width: 220px;
  height: 100%;
  font-size: 20px;
  border-right: 1px solid #e5e5e5;
  position: fixed;
  top: 52px;
  left: 0;
  .menu-title {
    height: 50px;
    line-height: 50px;
    padding: 0 15px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .icon {
      width: 16px;
      height: 16px;
      display: block;
    }
  }
  .menu-child {
    background: #f7f7f7;
    transition: height .5s ease;
    .menu-item {
      text-indent: 2em;
      height: 50px;
      line-height: 50px;
      cursor: pointer;
      &:hover {
        background: #eee;
      }
    }
  }
  .shrink {
    height: 0;
  }
  .active {
    color: #1684fc;
  }
}
::v-deep .content {
  margin-left: 220px;
  padding: 10px 15px;
  h1 {
    font-size: 20px;
  }
  h2 {
    font-size: 18px;
  }
  h3 {
    font-size: 16px;
  }
  h4 {
    font-size: 14px;
  }
  h1, h2, h3, h4 {
    margin: 10px 0;
  }
  p {
    font-size: 12px;
    padding: 2px 0;
  }
}
</style>
